'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _props3 = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email() {
    (0, _classCallCheck3.default)(this, Email);
    return (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).apply(this, arguments));
  }

  (0, _createClass3.default)(Email, [{
    key: '_getStyle',
    value: function _getStyle() {
      var additionalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          color = _props.color,
          fontSize = _props.fontSize,
          fontFamily = _props.fontFamily,
          fontStyle = _props.fontStyle,
          fontWeight = _props.fontWeight,
          textDecoration = _props.textDecoration,
          padding = _props.padding,
          margin = _props.margin,
          borderStyle = _props.borderStyle,
          borderWidth = _props.borderWidth,
          borderColor = _props.borderColor;


      return (0, _reactcss2.default)({
        default: {
          root: {
            color: color,
            fontSize: fontSize,
            fontFamily: fontFamily,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            textDecoration: textDecoration,
            padding: padding,
            margin: margin,
            borderStyle: borderStyle,
            borderWidth: borderWidth,
            borderColor: borderColor
          }
        }
      }, (0, _extends3.default)({}, this.props, additionalProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          id = _props2.id;

      var style = this._getStyle();

      return _react2.default.createElement(
        'span',
        { style: style.root, 'data-editor-id': id },
        value
      );
    }
  }]);
  return Email;
}(_react.Component), _class.propTypes = _props3.propTypes, _class.defaultProps = _props3.defaultProps, _temp);
exports.default = Email;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Label/Email/Email.jsx
// module id = 1542
// module chunks = 0